<script>
  import CardImage from "./CardImage.svelte";

  export let keyframeData;
</script>

<main>
  <key>
    <CardImage name={keyframeData['primaryURL']} />
  </key>

  {#if keyframeData['headline'] != null}
    <headline>
      <h1>{keyframeData['headline']}</h1>
    </headline>
  {/if}

  {#if keyframeData['secondaryURL'] != null}
    <sub>
      <CardImage name={keyframeData['secondaryURL']} />
    </sub>
  {/if}

  {#if keyframeData['tagline'] != null}
    <tag>
      <h2>{keyframeData['tagline']}</h2>
    </tag>
  {/if}
</main>

<style>
  main {
    height: 100%;
    width: 98%;
    display: grid;
    grid-gap: 5px;
    grid-template-columns: 60% 38%;
    grid-template-areas:
        "key tag"
        "key tag"
        "key sub"
        "key sub"
        "headline sub"
  ;
  }

  key {
    grid-area: key;
    max-height: 800px;
    display: flex;
    align-items: flex-end;
  }

  sub {
    grid-area: sub;
    max-height: 700px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 8px;
  }

  tag {
    grid-area: tag;
    display: flex;
    flex-direction: column-reverse;
    text-align: right;
  }

  headline {
    grid-area: headline;
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-left: 12px;
  }
  headline h1 {
    margin-top: 0;
    padding-top: 8px;
  }

  @media screen and (max-width: 1200px){
    h1 { font-size: 2.0rem; }
    h2 { font-size: 1.8rem; }
  }
  @media screen and (max-width: 800px){
    h1 { font-size: 1.7rem; }
    h2 { font-size: 1.4rem; }
  }
</style>